import {FC, useState, useEffect, Fragment} from 'react'
import Table from 'react-bootstrap/Table'
import {PageTitle} from '../../../../../_metronic/layout/core'

import {Col, Dropdown, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import FormModal from './FormModal'

import Api from '../../../../../thesis-and-dissertations/helpers/api'
import FormModuleModal from './FormModuleModal'

const api = new Api()

const heads = [
  {
    name: '',
    label: 'Nama Role',
  },
  {
    name: '',
    label: 'Deskripsi',
  },
  {
    name: '',
    label: 'Status',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const AssignRolePage: FC = () => {
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })

  const [show, setShow] = useState(false)
  const [showModule, setShowModule] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [formValue, setFormValue] = useState<any>({})
  const [loading, setLoading] = useState<any>(false)

  const [data, setData] = useState<any>({})

  const paginator: any = usePagination({
    totalCount: data?.total || 0,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  useEffect(() => {
    fetchData()
  }, [query])

  useEffect(() => {
    // generateTotalPage(pagination.total_page)
    fetchData()
  }, [pagination.per_page, pagination.page])

  // const generateTotalPage = (totalPage: number) => {
  //   let total = 0
  //   let newTotal: any = []

  //   for (total = 0; total < totalPage; total++) {
  //     if (total < 4) {
  //       newTotal.push(total + 1)
  //     } else if (total === 8) {
  //       newTotal.push('...')
  //       newTotal.push(totalPage)
  //     }
  //   }
  //   return newTotal
  // }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const handleClose = (isShow: boolean) => {
    setFormValue({})
    setShow(isShow)
    fetchData()
  }

  const handleCloseModule = (isShow: boolean) => {
    setShowModule(isShow)
  }

  const fetchData = () => {
    setLoading(true)
    api
      .getRole({
        ...query,
        page: pagination.page,
        sort_field: 'created_at',
        per_page: pagination.per_page,
      })
      .then((response: any) => {
        setLoading(false)
        const data = response.data
        setData(data.data)
      })
      .catch((error: any) => {
        setLoading(false)
      })
  }

  return (
    <>
      <div className='row'>
        <FormModal showFormModal={show} handleCloseFormModal={handleClose} formData={formValue} />

        <FormModuleModal
          showFormModal={showModule}
          handleCloseFormModal={handleCloseModule}
          formData={formValue}
        />

        <div className='col-md-12'>
          <div className='card-custom'>
            <Row>
              <Col md={{span: 4}}>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Cari...'
                  onChange={(e) => {
                    setPagination({...pagination, per_page: pagination.per_page, page: 1})
                    setQuery({...query, q: e.target.value})
                  }}
                />
              </Col>
              <Col md={{span: 2, offset: 4}}>
                <button
                  type='button'
                  onClick={() => setShow(true)}
                  className='btn btn-primary form-control'
                >
                  + Tambah
                </button>
              </Col>
              <Col md={{span: 2}}>
                <select
                  className='mr-8 form-control'
                  onChange={(e) => {
                    setQuery({...query, sort_order: e.target.value})
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </select>
              </Col>
            </Row>{' '}
            <Row md={12} className='mt-8'>
              <Table responsive className='table-striped align-middle'>
                <thead>
                  <tr>
                    <th>#</th>
                    {heads.map((item, index) => (
                      <th key={index} style={{maxWidth: item.label == 'Aksi' ? '100px' : ''}}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.data?.map((item: any, key: any) => {
                    return (
                      <tr key={key}>
                        <td>{key + 1}</td>
                        <td>{item.roles_name}</td>
                        <td>{item.roles_description}</td>
                        <td>
                          {item.roles_is_active == '0' ? (
                            <button
                              type='button'
                              className='shadow-none btn btn-sm btn-sm btn-outline btn-outline-dark'
                            >
                              Nonaktif
                            </button>
                          ) : (
                            <button
                              type='button'
                              className='shadow-none btn btn-sm btn-outline btn-outline-success'
                            >
                              Aktif
                            </button>
                          )}
                        </td>
                        <td>
                          <div className='d-grid gap-2 d-md-flex'>
                            <button
                              type='button'
                              className='btn btn-sm btn-primary'
                              onClick={() => {
                                setFormValue({
                                  id: item.roles_id,
                                  name: item.roles_name,
                                  description: item.roles_description,
                                  is_active: item.roles_is_active,
                                  id_hash: item.id_hash,
                                })

                                setShow(true)
                              }}
                            >
                              Edit
                            </button>

                            {/* <button
                              type='button'
                              className='btn btn-sm btn-primary'
                              onClick={() => {
                                setFormValue({
                                  id: item.roles_id,
                                  name: item.roles_name,
                                  description: item.roles_description,
                                  is_active: item.roles_is_active,
                                  id_hash: item.id_hash,
                                })

                                setShowModule(true)
                              }}
                            >
                              Module
                            </button> */}
                          </div>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </Row>
            <Row>
              <Col md={6}>
                {data?.data?.length > 0 && !loading && (
                  <div style={{float: 'left'}}>
                    <Dropdown>
                      <Dropdown.Toggle className='btn btn-sm'>
                        {pagination.per_page}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {[10, 25, 50, 100].map((item: any) => (
                          <Dropdown.Item
                            key={item}
                            onClick={() => onChangePerPage(item)}
                            disabled={pagination.per_page === item}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </Col>
              <Col md={6}>
                <div style={{float: 'right'}}>
                  {!loading && (
                    <Pagination className='btn-sm'>
                      {paginator?.map((item: any) => {
                        return (
                          <Pagination.Item
                            className='btn-sm'
                            key={item}
                            active={item === pagination.page}
                            onClick={() => onChangePerPage(pagination.per_page, item)}
                            disabled={item === '...'}
                          >
                            {item}
                          </Pagination.Item>
                        )
                      })}
                    </Pagination>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

const AssignRole: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Role Management
      </PageTitle>
      <AssignRolePage />
    </>
  )
}

export default AssignRole
